import { Component } from 'react';
import SeoHelper from '../lib/SeoHelper';

class SourceField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sources: '',
			loading: false,
		}

		this.getSearchResults = this.getSearchResults.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	async getSearchResults(event) {
		event.preventDefault();
		let {keyword, topic, language} = this.props;
		if (!keyword && !topic) {
			alert(window?.t?.PROVIDE_TOPIC_OR_KEYWORD);
			return;
		}
		this.setState({
			loading: true,
		});

		const urls = await SeoHelper.getTop10SearchResults(topic || keyword, language);
		if (urls.length) {
			let src = this.state.sources ? this.state.sources : this.props.value;
			src = src ? src + "\n" : '';
			src += urls.join("\n");
			this.setState({
				loading: false,
				sources: src,
			});
			this.props.changeCallback('sources', src);
		} else {
			this.setState({
				loading: false,
			});
		}
	}

	handleChange(event) {
		let urls = event.target.value.split("\n");
		if (urls.length > 10) {
			urls = urls.splice(0, 10);
		}
		const savedValue = urls.join("\n");
		this.setState({
			sources: savedValue,
		});
		this.props.changeCallback('sources', savedValue);
	}

	render() {
		return (
			<p>
				<label htmlFor="sources">{window?.t?.LBL_SRC_URLS}</label>
				<textarea id="sources" name="sources" rows="5" onChange={this.handleChange} value={this.state.sources || this.props.value}></textarea>
				<span className="hint">{window?.t?.ONE_URL_PER_LINE} {this.state.loading ? window?.t?.LOADING_SEARCH_RESULTS : (<>{window?.t?.USE_TOP10_AS_SRC1} <a href="/" onClick={this.getSearchResults}>{window?.t?.USE_TOP10_AS_SRC2}</a> {window?.t?.USE_TOP10_AS_SRC3}</>)}</span>
			</p>
		)
	}
}

export default SourceField;